import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const LocationsDatatable = lazy(() =>
  import("@components/Geofences/GeofenceView").then((module) => ({
    default: module.GeofenceView,
  }))
);

export const locationsNRO: NavigationRoutingObject = {
  section: "audience",
  Component: LocationsDatatable,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  heading: (t: I18nT<"dashboard-navigation">) => t("locations-pill-menu-option", "Locations"),
  pageNameForTracking: () => "Locations",
  description: (t: I18nT<"dashboard-navigation">) =>
    t("locations-description-nav", "Create geofences to trigger messages when a user enters or exits an area"),
  icon: "nav-system-locations",
  getDeveloperNavigationAllowed: ({ featureOn }) => featureOn("locations"),
  additionalSearchTerms: (t: I18nT<"dashboard-navigation">) => [
    {
      keywords: [t("locations-alt-keyword-1", "geofences")],
      description: t(
        "locations-description-nav",
        "Create geofences to trigger messages when a user enters or exits an area"
      ),
    },
  ],
  additionalSearchableFeatures: () => ({}),
};
